<template>
  <DashboardHost />
</template>
<script>
import DashboardHost from '@/components/dashboard/DashboardHost.vue'
export default {
  name: 'DashboardView',
  components: {
    DashboardHost
  }
}
</script>
<style lang="scss" scoped>
.custom-logo {
  width: 300px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
